<script lang="ts">
    import Icon from '@iconify/svelte'

    import { gettext as _, resolve, tgettext, type TGettext } from 'hydria/services/gettext'

    import VerticalFieldWidget from '../Widgets/VerticalFieldWidget.svelte'
    import type { SvelteSet } from 'svelte/reactivity'

    interface Align {
        id: string | null
        text: TGettext
        icon: string | null
        iconText?: string
    }

    interface Props {
        saved: string | undefined | null
        value: string | undefined | null
        allowed?: Array<string | null>
        enabled?: SvelteSet<string | null> | undefined
        disabled?: boolean
        grouped?: boolean
        aligns?: Align[] | null
        label?: any
        save: (v: string) => void
    }

    let { saved: savedValue, value: currentValue, allowed = undefined, enabled = undefined, disabled = false, grouped = true, aligns = $bindable(null), label = tgettext('Alignement'), save }: Props = $props()
    const DEFAULT_ALIGNS = [
        { id: 'start', text: tgettext('Gauche'), icon: 'mdi:format-align-left' },
        { id: 'center', text: tgettext('Centre'), icon: 'mdi:format-align-center' },
        { id: 'end', text: tgettext('Droit'), icon: 'mdi:format-align-right' },
    ]
    if (aligns == null) {
        aligns = [...DEFAULT_ALIGNS]
    }
    let allowedValues = $state(new Set(aligns.map((i) => i.id)))
    if (allowed != null) {
        allowedValues = new Set([...allowedValues].filter((v) => allowed.includes(v)))
    }

    let value: string | undefined = $derived(currentValue ? currentValue : undefined)

    // @ts-expect-error
    let isValid = $derived(allowedValues.has(value))

    let isPristine = $derived(currentValue === savedValue)

    let allowedAligns: Align[] = $derived(aligns.filter((align) => allowedValues.has(align.id)))

    let allIconText: boolean = $derived(allowedAligns.filter((align) => align.icon == null && align.iconText != null).length === allowedAligns.length)

    function keep(value: string) {
        save(value)
    }
</script>

<style>
    .ungrouped {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        justify-content: center;
    }
</style>

<VerticalFieldWidget {label} {isPristine} {isValid}>
    <div class:btn-group-sm={allIconText && grouped} class:btn-group={grouped} class:ungrouped={!grouped}>
        {#each aligns as align}
            {#if allowedValues.has(align.id)}
                <button type="button" class="btn btn-outline-secondary" class:active={value == align.id} onclick={() => keep(align.id)} disabled={disabled || (enabled != null && !enabled.has(align.id))} data-tooltip={$resolve(align.text)} class:btn-sm={align.icon == null && align.iconText != null}>
                    {#if align.icon != null}
                        <Icon inline icon={align.icon} />
                    {:else if align.iconText != null}
                        {align.iconText}
                    {:else}
                        ?
                    {/if}
                </button>
            {/if}
        {/each}
    </div>
</VerticalFieldWidget>
